"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const useRatingTemplate_1 = require("src/hooks/api/useRatingTemplate");
const TrackDetailItem = ({ index, track }) => {
    const trackTemplate = track?.template;
    const isTrackReviewAspects = track?.type === 'review_aspects_scoring';
    const { data: trackReviewAspect } = (0, useRatingTemplate_1.useGetRatingTemplateDetail)(trackTemplate?.reviewAspects?.[0]?.ratingTemplateId, {
        enabled: isTrackReviewAspects,
        staleTime: 5 * 60 * 1000
    });
    const trackTemplateName = trackTemplate?.name || (0, HelperUtils_1.getObjectiveLocale)('No Template on Track');
    const ratingTemplateName = (isTrackReviewAspects
        ? trackReviewAspect?.data?.name
        : trackTemplate?.ratingTemplate?.name) ||
        (0, HelperUtils_1.getObjectiveLocale)('No Rating Template');
    return (react_1.default.createElement("div", { key: index, className: "flex mt-[20px] h-[36px] items-center" },
        react_1.default.createElement("div", { className: "text-n-900 w-[48px] text-center number" }, index + 1),
        react_1.default.createElement("div", { className: "min-w-[268px] px-[16px] py-[10px]" },
            react_1.default.createElement("p", { className: "typography-h400 text-n-900 truncate max-w-[218px]" }, track?.name),
            react_1.default.createElement("p", { className: "typography-h100 text-n-800 mt-[4px] max-w-[218px]" }, (0, HelperUtils_1.capitalizeSentence)(track?.type?.replace(/_/g, ' ')))),
        react_1.default.createElement(TooltipContainer_1.default, { show: true, text: trackTemplateName },
            react_1.default.createElement("div", { className: "text-n-900 truncate w-[218px] px-[8px]" }, trackTemplateName)),
        react_1.default.createElement(TooltipContainer_1.default, { show: true, text: ratingTemplateName },
            react_1.default.createElement("div", { className: "text-n-900 truncate w-[218px] px-[8px]" }, ratingTemplateName))));
};
exports.default = TrackDetailItem;
